import React from 'react';
import withStore from "@/hocs/withStore";
import BaseLayout from "@/Layouts/BaseLayout";
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import '@/Pages/PlatinaBenefits/scss/index.scss';
import LinkLoad from "@/Layouts/LinkLoad";
import {getProperty} from "@/Helpers/Function";

class PlatinaBenefits extends React.Component {
    render() {
        const {mobileApp = false, stores = {}, homeStepsData, data = []} = this.props;
        const {profileStore = {}} = stores;
        const {
            top: {
                imgWebp = '',
                imgJpg = '',
                descriptionTop = '',
                descriptionBottom = ''
            },
            statuses = [],
        } = data;

        return <BaseLayout {...this.props}>
            <section className={`section`}>
                {!mobileApp && (
                    <div className={`breadcrumbs`}>
                        <div className={`container`}>
                            <Breadcrumbs
                                maxItems={2}
                                itemsAfterCollapse={2}
                            >
                                <LinkLoad className={`breadcrumbs__link`} href={`/`}>
                                    Главная
                                </LinkLoad>
                                <p className={`breadcrumbs__text`}>
                                    Бонусная программа
                                </p>
                            </Breadcrumbs>
                        </div>
                    </div>
                )}
                <div className={`bonusProgram`}>
                    <div className={`container`}>
                        <div className={`bonusProgramImage`}>
                            <picture>
                                <source type={`image/webp`}
                                        srcSet={imgWebp}
                                />
                                <img src={imgJpg}
                                     alt={`benefits`}
                                     title={`benefits`}
                                     loading={`lazy`}
                                     width={`1310`}
                                     height={`768`}
                                />
                            </picture>
                        </div>
                        <p className={`bonusProgramDescription`}>{descriptionTop}</p>
                        <p className={`bonusProgramDescription`}>{descriptionBottom}</p>
                        {
                            statuses.map((n, i) => ({...n, id: i + 1})).map((item) => (
                                <div key={item.id} className={`status`}>
                                    <p className={`status__name status__name`}>{item.name}</p>
                                    <p className={`status__description`}>{item.desc}</p>
                                    <div className={`status__list`}>
                                        {
                                            item.list.map((n, i) => ({...n, id: i + 1}))
                                                .map((el) => (
                                                    <div key={el.id} className={`status__item`}>
                                                        <div className={`icon`}>
                                                            <picture>
                                                                <source type={`image/webp`}
                                                                        srcSet={getProperty(el, 'iconWebp', '')}
                                                                />
                                                                <img src={getProperty(el, 'iconPng', '')}
                                                                     alt={`icon`}
                                                                     title={`icon`}
                                                                />
                                                            </picture>
                                                        </div>
                                                        <p className={`text`}>{getProperty(el, 'text', '')}</p>
                                                    </div>
                                                ))
                                        }
                                    </div>
                                </div>
                            ))
                        }
                        {!mobileApp && (
                            <div className={`getClubCard`}>
                                <LinkLoad href={`/home`}
                                          onClick={() => profileStore.onClickNav(2, homeStepsData)}
                                          className={`btn btn__getClubCard`}>
                                    Личный кабинет Бонусной программы
                                </LinkLoad>
                            </div>
                        )}
                        <p className={`disclaimer`}>
                            * Списание бонусов на определенные товары в рамках специальных акций Организатора Программы
                            может быть ограничено или невозможно
                        </p>
                        <div className={`fullRules`}>
                            Более подробно с правилами бонусной программы можно ознакомиться <LinkLoad
                            href={`/platina-benefits-rules`} className={`fullRules__link`}>здесь.
                        </LinkLoad>
                        </div>
                    </div>
                </div>
            </section>
        </BaseLayout>
    }
}

export default withStore(PlatinaBenefits)


